<div class="relative">

  <div *ngIf="showLabelOnTop" class="text-sm font-semibold mb-1"
    [ngClass]="labelActive ? 'text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'">
    {{ label }}
  </div>

  <button [class]="class"
    class="relative flex items-center justify-between px-1 py-2 bg-white border border-gray-300 rounded-md shadow-sm dark:bg-gray-800 dark:border-none"
    (click)="toggleDropdown()">

    <div class="flex items-center">
      <ng-content select="[multi-select-icon]"></ng-content>
      <div class="flex flex-grow ml-2 dark:text-gray-400 flex flex-row gap-2 text-[14px]">

        <span *ngIf="!selected.length && !hideSelectedText">{{ placeholderMessage || 'Select ' + label }}</span>

        <span *ngIf="selected.length && !hideSelectedText">{{ selectedDisplayText }}</span>

        <ng-container *ngIf="!commaDelimited">
          <lucide-angular [name]="labelIcon" *ngIf="labelIcon" [style]="iconStyle" />
          <div class="flex flex-row justify-between w-full">
            <span class="font-bold">{{ label }}</span>
            <span class="font-light">{{ selectedLabelValue }}</span>
          </div>
        </ng-container>
      </div>
    </div>


    <svg class="w-5 h-5 text-gray-500 ml-2 transform transition-transform duration-300"
      [class.rotate-180]="showDropdown" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <div *ngIf="showDropdown" [ngStyle]="{ width: boxSize ? boxSize + 'px' : '100%' }" (mouseleave)="onMouseLeave()"
    (mouseenter)="onMouseEnter()"
    [ngClass]="{'dropdown-right': dropdownPosition === 'right', 'dropdown-left': dropdownPosition === 'left'}"
    class="absolute z-[80] mt-1 bg-white rounded-md shadow-lg p-3 dark:bg-gray-600">

    <!-- Select All / Deselect All Options -->
    <div *ngIf="selectAllSetting" class="flex justify-between mb-2">
      <button (click)="selectAll()" class="text-blue-500 text-sm hover:underline">Select All</button>
      <button (click)="deselectAll()" class="text-red-500 text-sm hover:underline">Deselect All</button>
    </div>

    <div class="flex flex-row relative items-center" *ngIf="!disabledSearchBox">
      <div class="absolute text-gray-500 left-4 top-1/2 transform -translate-y-1/2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6">
          <path fill-rule="evenodd"
            d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
            clip-rule="evenodd" />
        </svg>
      </div>

      <input type="search"
        class="rounded-lg pl-12 py-2 w-full text-base text-gray-600 bg-white border border-gray-200 focus:outline-none transition-all duration-300 ease-in-out dark:bg-gray-800 dark:border-none"
        [(ngModel)]="searchTerm" (ngModelChange)="filterOptions()" placeholder="Search..." />

      <div class="absolute right-10 inset-y-0 my-auto" *ngIf="foundCount">
        {{ foundCount }}
      </div>

      <div class="absolute right-4 inset-y-0 my-auto" (click)="searchTerm = ''" *ngIf="searchTerm.length">
        <i lucide="x-circle" class="cursor-pointer"></i>
      </div>
    </div>

    <ul class="overflow-auto mt-2 max-list">
      <li *ngFor="let option of filteredOptions; let i = index" [ngClass]="{
              'bg-gray-100 hover:bg-gray-200 dark:bg-gray-500': i % 2 === 0,
              'bg-white hover:bg-gray-100 dark:bg-gray-600 ': i % 2 !== 0
            }"
        class="flex items-center px-4 py-2 cursor-pointer rounded-md transition-colors duration-150 ease-in-out text-sm">
        <div class="flex items-center">
          <input [type]="singleSelection ? 'radio' : 'checkbox'"
            [name]="singleSelection ? 'singleSelect' : 'multiSelect'" [checked]="isSelected(option)"
            class="form-checkbox h-5 w-5 text-blue-600" (click)="selectOption(option)" />
        </div>
        <span class="ml-2 flex-grow dark:text-gray-300">{{ option[labelKey] | decodeHtml }}</span>
        <ng-container *ngTemplateOutlet="
            extraContentTemplate;
            context: { $implicit: option }
          "></ng-container>
      </li>
    </ul>
  </div>
</div>
